import {
    AUTHENTICATE_SALESFORCE_REQUEST, AUTHTENTICATING_SALESFORCE_SUCCEEDED, AUTHTENTICATING_SALESFORCE_FAILED,
    UPDATE_SALESFORCE_REQUEST, UPDATING_SALESFORCE_SUCCEEDED, UPDATING_SALESFORCE_FAILED
  } from 'constants/actionTypes';
  
  const initialState = {
    changes: {
      saving: false,
      updating: false,
      error: null
    }
  };
  
  function salesforceReducer(state = initialState, action) {
    switch (action.type) {
  
      case AUTHENTICATE_SALESFORCE_REQUEST: {
        return {
          ...state,
          changes: {
            ...state.changes,
            saving: true,
            error: null
          }
        }
      }
  
      case AUTHTENTICATING_SALESFORCE_SUCCEEDED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            saving: false,
            error: null
          }
        }
      }
  
      case AUTHTENTICATING_SALESFORCE_FAILED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            saving: false,
            error: action.payload
          }
        }
      }
  
      case UPDATE_SALESFORCE_REQUEST: {
        return {
          ...state,
          changes: {
            ...state.changes,
            updating: true,
            error: null
          }
        }
      }
  
      case UPDATING_SALESFORCE_SUCCEEDED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            updating: false,
            error: null
          }
        }
      }
  
      case UPDATING_SALESFORCE_FAILED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            updating: false,
            error: action.payload
          }
        }
      }
  
      default:
        return state;
    }
  }
  
  export { salesforceReducer };